<template>
  <div>
    <GrossProfitRateDetail v-if="item.categoryName == '毛利率'" :item="item" :store-id="storeId" :role="role"
        :turn-type="turnType" @back="back" @addCallbackTask="handleViewTask"></GrossProfitRateDetail>
    <EmptyShopDetail v-if="item.categoryName == '空铺'" :item="item" :store-id="storeId" :role="role"
        :turn-type="turnType" @back="back" @addCallbackTask="handleViewTask"></EmptyShopDetail>
    <PassengerFlowDetail v-if="item.categoryName == '客流'" :item="item" :store-id="storeId" :role="role"
        :turn-type="turnType" @back="back" @addCallbackTask="handleViewTask"></PassengerFlowDetail>
    <TradingAreaDetail v-if="item.categoryName == '商圈积分'" 
	    :item="item" @back="back" @addCallbackTask="handleViewTask"></TradingAreaDetail>
	<RevenueDetail v-if="item.categoryName == '营收'" :item="item" :store-id="storeId" :role="role"
        :turn-type="turnType" @back="back" @addCallbackTask="handleViewTask"></RevenueDetail>
	<CollectionRateDetail v-if="item.categoryName == '收缴率'" :item="item" :store-id="storeId" :role="role"
		:turn-type="turnType" @back="back" @addCallbackTask="handleViewTask"></CollectionRateDetail>
	<RentSaleRateDetail v-if="item.categoryName == '租售比'" :item="item" :store-id="storeId" :role="role"
		:turn-type="turnType" @back="back" @addCallbackTask="handleViewTask"></RentSaleRateDetail>	
  </div>
</template>

<script>
import GrossProfitRateDetail from "../../../components/alarm/grossProfitRateDetail";
import EmptyShopDetail from "../../../components/alarm/emptyShopDetail"
import PassengerFlowDetail from "../../../components/alarm/passengerFlowDetail";
import TradingAreaDetail from "../../../components/alarm/tradingAreaDetail";
import RevenueDetail from "../../../components/alarm/revenueDetail";
import CollectionRateDetail from "../../../components/alarm/collectionRateDetail"
import RentSaleRateDetail from "../../../components/alarm/RenSaleRateDetail" 
import { default as AlarmOrderApi } from '@/api/alarm/order/AlarmOrderApi.js'
import {default as PermissionApi} from "@/api/smp/auth/Permission";
export default {
  name: "messageDetails",
  components: {
    GrossProfitRateDetail,
    EmptyShopDetail,
    PassengerFlowDetail,
    TradingAreaDetail,
	RevenueDetail,
	CollectionRateDetail,
	RentSaleRateDetail
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    storeId: {
      type: String,
      default: ""
    },
    role: {
      type: Number
    },
    page: {
      type: Object,
      default: null
    },
    turnType: {
      type: Number,
      default: 0
    },
	audit: {
		type:Number,
		default: 0
	},
	type: {
		type: Number,
		default: 0
	}
  },
  data() {
    return {
      buttonPriviledgeList: []
    }
  },
  created() {
    this.getButtonPriviledge()
  },
  mounted() {
    console.log(this.item)
  },
  methods: {
    back() {
      this.$emit("back", {formStatus:'list'})
    },
    handleViewTask() {
      console.log(1)
      this.$emit("addCallbackTask", {formStatus:'task', item: this.item, type: this.type, return: 2, audit: this.audit})
    },
    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>